import React from 'react'
import classes from './Loading.module.css'
function Loading() {
    return (
        <div className={classes.loader}>
            Loading...
        </div>
    )
}

export default Loading
